<template>
  <b-modal
    v-model="isOpen"
    scrollable
    centered
    :title="title"
    size="lg"
    @hidden="onClose"
    @ok="onClose"
  >
    <div class="pb-5">
      <div class="mb-2">
        <div class="small font-weight-bold mb-1">
          Номер консультации
        </div>
        <base-async-select
          v-model="$v.consultation.$model"
          :error="$v.consultation.$error"
          :fetch-function="fetchConsultations"
          loading-title="Загрузка консультаций"
          no-options-title="Консультации не найдены"
          server-paginated
          fluid
        />
        <div
          v-if="$v.consultation.$error"
          class="mt-2 text-danger small"
        >
          {{ errorsValidation.consultation[0] }}
        </div>
      </div>
      <div class="mb-2">
        <div class="small font-weight-bold mb-1">
          Целевой врач:
        </div>
        <v-select
          v-model="$v.selectedSpecialization.$model"
          :options="specializations"
          placeholder="Выберите специализацию"
          fluid
          label="name"
        />

        <div
          v-if="$v.selectedSpecialization.$error"
          class="mt-2 text-danger small"
        >
          {{ errorsValidation.selectedSpecialization[0] }}
        </div>
      </div>
      <div class="mb-2">
        <div class="small font-weight-bold mb-1">
          ФИО врача:
        </div>
        <base-async-select
          :key="selectedSpecialization ? selectedSpecialization.id : null"
          v-model="$v.selectedDoctor.$model"
          :fetch-function="fetchDoctors"
          placeholder="Выберите врача"
          loading-title="Загрузка докторов"
          no-options-title="Доктора не найдены"
          server-paginated
          fluid
        />
        <div
          v-if="$v.selectedDoctor.$error"
          class="mt-2 text-danger small"
        >
          {{ errorsValidation.selectedDoctor[0] }}
        </div>
      </div>
      <div class="mb-2">
        <div class="small font-weight-bold mb-1">
          Инициатор
        </div>
        <b-select
          v-model="$v.selectedInitiatorId.$model"
          value-field="id"
          text-field="name"
          :options="initiators"
        />
        <div
          v-if="$v.selectedInitiatorId.$error"
          class="mt-2 text-danger small"
        >
          {{ errorsValidation.selectedInitiatorId[0] }}
        </div>
      </div>
      <div class="mb-3">
        <div class="small font-weight-bold mb-1">
          Причина переноса консультации
        </div>
        <base-async-select
          :key="selectedInitiatorId"
          v-model="$v.selectedTransferReason.$model"
          :fetch-function="fetchTransferReasons"
          :disabled="$v.selectedInitiatorId.$model === null"
          placeholder="Выберите причину"
          loading-title="Загрузка"
          no-options-title="Причины не найдены"
          server-paginated
          fluid
        />

        <div
          v-if="$v.selectedTransferReason.$error"
          class="mt-2 text-danger small"
        >
          {{ errorsValidation.selectedTransferReason[0] }}
        </div>
      </div>

      <div v-if="selectedDoctor">
        <div class="schedule">
          <schedule-wrapper :doctor-id="selectedDoctor.id">
            <schedule @change-active-tab="activeTimeTab = $event" />
          </schedule-wrapper>

          <div
            v-if="$v.activeTimeTab.$error"
            class="mt-2 text-danger small"
          >
            {{ errorsValidation.activeTimeTab[0] }}
          </div>
        </div>
      </div>
    </div>

    <template #modal-footer>
      <b-button
        variant="danger"
        :disabled="isSaving"
        @click="onClose"
      >
        Отменить
      </b-button>
      <b-button
        variant="primary"
        :disabled="isSaving"
        class="ml-2"
        @click="onClickSave"
      >
        Перенести
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';

import Bus from '@/eventBus';

import { showMessage } from '@/helpers/utils';
import { BaseAsyncSelect } from '@/components/base';
import ScheduleWrapper from '@/components/Schedule/Modals/ScheduleWrapper';
import Schedule from '@/components/Schedule/Modals/Schedule';

export default {
  name: 'ConsultationTransferModal',
  components: {
    BaseAsyncSelect,
    ScheduleWrapper,
    Schedule,
  },
  mixins: [validationMixin],
  props: {
    consultationProp: {
      type: Object,
      default: () => ({}),
    },
    modalName: {
      type: [String, Number],
      default: null,
    },
    title: {
      type: String,
      default: 'Перенос консультации',
    },
  },
  data() {
    return {
      isOpen: true,
      consultation: null,
      selectedDoctor: null,
      selectedTransferReason: null,
      selectedSpecialization: null,
      activeTimeTab: null,
      specializations: [],
      selectedInitiatorId: null,
      initiators: [
        {
          id: 0,
          name: 'Врач',
        },
        {
          id: 1,
          name: 'Пациент',
        },
        {
          id: 2,
          name: 'Техническая ошибка',
        },
        {
          id: 3,
          name: 'Администратор',
        }],
      isSaving: false,
    };
  },
  validations() {
    return {
      consultation: {
        required,
      },
      selectedSpecialization: {},
      selectedDoctor: {
        required,
      },
      selectedInitiatorId: {
        required,
      },
      selectedTransferReason: {
        required,
      },
      activeTimeTab: {
        // required,
      },
    };
  },
  computed: {
    errorsValidation() {
      const errors = {};

      errors.consultation = [];
      if (!this.$v.consultation.required) {
        errors.consultation.push('Поле не может быть пустым');
      }

      errors.selectedDoctor = [];
      if (!this.$v.selectedDoctor.required) {
        errors.selectedDoctor.push('Поле не может быть пустым');
      }

      errors.selectedTransferReason = [];
      if (!this.$v.selectedTransferReason.required) {
        errors.selectedTransferReason.push('Поле не может быть пустым');
      }

      errors.selectedInitiatorId = [];
      if (!this.$v.selectedInitiatorId.required) {
        errors.selectedInitiatorId.push('Поле не может быть пустым');
      }

      errors.activeTimeTab = [];
      if (!this.$v.activeTimeTab.required) {
        errors.activeTimeTab.push('Необходимо выбрать слот');
      }

      return errors;
    },
  },
  watch: {
    selectedSpecialization() {
      this.selectedDoctor = null;
    },
    selectedDoctor() {
      this.activeTimeTab = null;
    },
  },
  async created() {
    this.consultation = this.formatConsultation(this.consultationProp);
    this.specializations = await this.fetchSpecializations('');
  },
  methods: {
    onClose() {
      this.$store.commit(this.$types.CLOSE_MODAL, { modalName: this.modalName });
    },
    async fetchDoctors({ query, skip, take }) {
      const doctors = await this.$store.dispatch(this.$types.DOCTORS_FETCH, {
        skip,
        take,
        query,
        doctorSpecializationId: this.selectedSpecialization.id,
        save: false,
      });

      return doctors.map((doctor) => ({ ...doctor, value: doctor.id, name: doctor.fullName }));
    },
    async fetchTransferReasons() {
      const reasons = await this.$store.dispatch(this.$types.TRANSFER_REASONS_FETCH, this.selectedInitiatorId);

      return reasons.map((reason) => ({ ...reason, value: reason.id, name: reason.reason }));
    },
    async fetchSpecializations(query) {
      const data = await this.$store.dispatch(this.$types.SPECIALIZATIONS_SEARCH, query);

      return data;
    },
    async fetchConsultations({ query, skip, take }) {
      const consultations = await this.$store.dispatch(this.$types.CONSULTATIONS_FETCH, {
        skip,
        take,
        query,
      });

      return consultations.map((consultation) => this.formatConsultation(consultation));
    },
    async onClickSave() {
      this.$v.$touch();

      if (this.$v.$error) {
        showMessage({
          type: 'warning',
          title: 'Ошибка валидации',
          message: 'Проверьте правильность заполнения полей',
        });

        return;
      }

      try {
        this.isSaving = true;

        await this.$store.dispatch(this.$types.CONSULTATIONS_TRANSFER, {
          consultationId: this.consultation.value,
          targetDoctorSpecializationId: this.selectedDoctor.mainDoctorSpecialization.id,
          transferReason: this.selectedTransferReason.id,
          unixTime: this.activeTimeTab,
        });

        this.$store.commit(this.$types.PATIENT_DETAIL_CONSULATIONS_RESET);
        Bus.$emit('consultations:update', this.consultation.value);
        this.$store.commit(this.$types.TOGGLE_SCHEDULE_TRIGGER); // сделает тогл триггера и обновит расписание
        this.onClose();
      } finally {
        this.isSaving = false;
      }
    },
    formatConsultation(consultation) {
      const { lastName, firstName, middleName } = consultation.patient;
      return {
        value: consultation.id,
        name: `${consultation.id} — ${lastName} ${firstName} ${middleName}`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.schedule {
  width: 100%;
  position: relative;
}
</style>
